import angular from 'angular';

import ApiService from './api.service';
import AuthService from './auth.service';
import CourseService from './course.service';
import HelperService from './helper.service';
import DiagramService from './diagram.service';
import AudioService from './audio.service';
import PyramidBuilderService from './pyramidBuilder.service';
import UserService from './user.service';
import CourseVideoService from './courseVideo.service';

const services = angular.module('minto.services', []);

services.service('apiService', ApiService);
services.service('courseService', CourseService);
services.service('authService', AuthService);
services.service('helperService', HelperService);
services.service('diagramService', DiagramService);
services.service('audioService', AudioService);
services.service('pyramidBuilderService', PyramidBuilderService);
services.service('userService', UserService);
services.service('courseVideoService', CourseVideoService);

export default services;



// WEBPACK FOOTER //
// ./client/app/services/services.module.js